import React from 'react';
import './VideoRecommendations.css';

function VideoRecommendations({ recommendations }) {
  const formatTimestamp = (seconds) => {
    if (!seconds) return '0:00';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hours > 0) {
      return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${secs.toString().padStart(2, '0')}`;
  };

  // Generate a gradient background based on title for unique thumbnails
  const getThumbnailStyle = (title) => {
    const colors = [
      ['#2596be', '#1a6d8f'],
      ['#be4d25', '#8f3a1a'],
      ['#25be6d', '#1a8f51'],
      ['#be2596', '#8f1a6d'],
      ['#6d25be', '#511a8f'],
      ['#bea325', '#8f7a1a'],
    ];
    const index = title.length % colors.length;
    return {
      background: `linear-gradient(135deg, ${colors[index][0]}, ${colors[index][1]})`
    };
  };

  return (
    <div className="video-recommendations">
      <h3>📺 Recommended Videos</h3>
      <p className="recommendations-subtitle">Learn more from these instructionals</p>
      
      <div className="recommendations-list">
        {recommendations.map((rec, index) => (
          <div key={index} className="recommendation-card">
            <div className="card-thumbnail" style={getThumbnailStyle(rec.title)}>
              <span className="thumbnail-icon">🥋</span>
              <span className="thumbnail-label">BJJ Fanatics</span>
            </div>
            
            <div className="card-content">
              <div className="card-header">
                <h4>{rec.title}</h4>
                <span className="relevance-badge">
                  {Math.round(rec.relevance_score * 100)}% match
                </span>
              </div>
              
              {rec.timestamp && (
                <div className="timestamp-info">
                  <span className="timestamp-icon">⏱️</span>
                  <span>
                    Start at {formatTimestamp(rec.timestamp)}
                    {rec.timestamp_end && ` - ${formatTimestamp(rec.timestamp_end)}`}
                  </span>
                </div>
              )}
              
              <p className="preview-text">{rec.preview_text}</p>
              
              <a
                href={rec.purchase_url}
                target="_blank"
                rel="noopener noreferrer"
                className="purchase-button"
              >
                View on BJJFanatics →
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VideoRecommendations;
